import React from 'react';
import { Crown, Shield, Edit3, Eye } from 'lucide-react';

const ROLE_CONFIG: Record<string, { label: string; icon: React.ComponentType<{ className?: string }>; classes: string }> = {
  owner: {
    label: 'Owner',
    icon: Crown,
    classes: 'bg-purple-500/15 text-purple-700 dark:text-purple-300 border-purple-500/30',
  },
  admin: {
    label: 'Admin',
    icon: Shield,
    classes: 'bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-500/30',
  },
  editor: {
    label: 'Editor',
    icon: Edit3,
    classes: 'bg-green-500/15 text-green-700 dark:text-green-300 border-green-500/30',
  },
  viewer: {
    label: 'Viewer',
    icon: Eye,
    classes: 'bg-gray-500/15 text-gray-700 dark:text-gray-300 border-gray-500/30',
  },
};

interface RoleBadgeProps {
  role: string | undefined;
  className?: string;
  /** Hide the icon (label only) for compact spaces. */
  iconless?: boolean;
}

export const RoleBadge: React.FC<RoleBadgeProps> = ({ role, className = '', iconless = false }) => {
  const normalized = (role ?? '').toLowerCase();
  const config = ROLE_CONFIG[normalized] ?? ROLE_CONFIG.viewer;
  const Icon = config.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium border rounded-full ${config.classes} ${className}`}
      title={`Role: ${config.label}`}
    >
      {!iconless && <Icon className="w-3 h-3" />}
      {config.label}
    </span>
  );
};

export default RoleBadge;
